<template>
  <b-modal
    id="delete-card"
    size="sm"
    centered
    hide-header
    cancel-variant="none"
    ok-title="Xoá"
    cancel-title="Quay lại"
    ok-variant="danger"
    @ok="deleteAction_DME01()"
  >
    <b-card-header class="banned-background-color">
      <div class="d-flex justify-content-between align-items-center block-header">
        <p class="mb-0 title-modal color-red">{{$t('golf_member_card_delete')}}</p>
        <ez-icon @click="hideModal" icon="ezGolf-icon-x" :color="`red`" class="cursor" :size="24"/>
      </div>
    </b-card-header>
    <b-card-body>
      <p class="mb-0 pt-2 pb-2 text">{{$t('golf_member_card_sure_delete')}}</p>
    </b-card-body>
  </b-modal>
</template>

<script>
import {memberCard} from '@/api/member-card';

export default {
  props: [
    'item'
  ],
  methods: {
    hideModal() {
      this.$bvModal.hide('delete-card')
    },
    async deleteAction_DME01() {
      const response = await memberCard.deleteCard({
        MemberCard: {
          Id: this.item.Id,
        }
      })

      if (response.Status === '200') {
        this.showResToast(response)
        this.$emit('event', {type: 'save_success'})
      } else {
        this.showResToast(response)
      }
    },
  }
}
</script>

<style lang="scss">
#delete-card {
  .card-header.banned-background-color {
    .color-red {
      color: #EA5455;
    }
    background: rgba(234, 84, 85, 0.12) !important;
    border-radius: 6px 6px 0px 0px;
    padding: 0 18px;
    .title-modal {
      padding: 10px 0;
      font-size: 18px;
      line-height: 21px;
      font-weight: 500;
      height: 48px;
      display: flex;
      align-items: center;
    }
    .text {
        color: #5D5F65;
        font-size: 12px;
        line-height: 18px;
      }
  }
}
</style>
